import {useEffect, useContext, useRef} from "react"
import {Toast} from "primereact/toast"
import RefContext from "./RefContext"

function ToastMessage(props) {
    const toast = useRef(null)
    const {add} = useContext(RefContext)

    const severityMapping = {
        success: "success",
        danger: "error",
        warning: "warn",
        info: "info",
    }

    const showToast = (toastData) => {
        if (toastData.show && toastData.text) {
            const severity = severityMapping[toastData.variant] || "info"

            toast.current?.show({
                severity: severity,
                summary: "",
                detail: toastData.text,
                life: toastData.timeout ?? 5000,
                sticky: toastData.timeout ? false : true,
                closable: true,
            })
        }
    }

    useEffect(() => {
        add("showToast", showToast)
    }, [add])

    return <Toast ref={toast} position="top-center" className="halo-toast" />
}

export default ToastMessage
